import React, {useState} from "react";
import useEditableTableTextCell from "../../../hooks/useEditableTableTextCell";
import useEditableTableCostCell from "../../../hooks/useEditableTableCostCell";
import {Form} from "react-bulma-components";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import useInlineEditButton from "../../../hooks/useInlineEditButton";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../../state/selectors";
import axios from "axios";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function MovementRateRow({rate, dataFresh, handleChange, handleSave, index}){
    const [editable, setEditable] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();


    const onChange = e => {
        handleChange(e,index)
    }

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "customer",
                value: e[0]
            }
        };
        onChange(toUpdate);
    }

    const onSave = e => {
        handleSave(rate);
        setEditable(false);
    }

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const handleHide = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        }
        onChange(toUpdate)
    }

    return (
        <tr>
            <td>
                {useEditableTableTextCell({
                    propName: "name",
                    value: rate.name,
                    onSave,
                    onChange,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "cost_per_mile",
                    value: rate.cost_per_mile,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "vehicle_cost",
                    value: rate.vehicle_cost,
                    onSave,
                    onChange,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "additional_time_cost",
                    value: rate.additional_time_cost,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "callout_cost",
                    value: rate.callout_cost,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "supplier_cost_per_mile",
                    value: rate.supplier_cost_per_mile,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "supplier_one_off_charge",
                    value: rate.supplier_one_off_charge,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "external_cost_per_mile",
                    value: rate.external_cost_per_mile,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "external_one_off_charge",
                    value: rate.external_one_off_charge,
                    onChange,
                    onSave,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"customer"}
                  onSearch={handleSearch}
                  onChange={handleContactSelect}
                  placeholder={"Search Customer"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={
                    rate.customer && rate.customer.id ? [rate.customer] : []
                  }
                />
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName:"comments",
                    value: rate.comments,
                    onSave,
                    onChange,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                <Form.Field className={"has-addons"}>
                    <Form.Control>
                        <Form.Checkbox
                            checked={rate.hide}
                            name={"hide"}
                            onChange={handleHide}
                        />
                    </Form.Control>
                    {useInlineEditButton({
                        show: true,
                        onSave,
                        editable,
                        setEditable,
                        disabled: false
                    })}
                </Form.Field>
            </td>
        </tr>
    )


}